/* eslint-disable no-alert */
/* eslint-disable jsx-a11y/label-has-associated-control */
import { yupResolver } from "@hookform/resolvers/yup";
import React, { useRef, useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import CryptoJS from "crypto-js";
import JSEncrypt from "jsencrypt";
import { useForm } from "react-hook-form";
import InputField from "../../Components/InputField/InputField";
import { handleKeyDown } from "../../Components/Utility/Utility";
//import { ContactFormSchema } from "../../components/schema/contact-form-schema";
//import styles from "../../styles/contact-us.less";
//import { VTIGER_ENCRYPTION_KEY, VTIGER_RSA_PUBLIC_KEY } from "../../helper/constant";

const VtigerContactForm = () => {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [file, setFile] = useState(null);
    const formRef = useRef(null);
    const recaptchaRef = useRef(null);

    const {
        register,
        handleSubmit,
        setValue,
        getValues,
        trigger,
        formState: { errors, isValid },
    } = useForm({
        mode: "onChange",
        defaultValues: {
            recaptcha: "",
        },
    });

    // const formValues = watch();

    const onSubmit = async (data) => {

        const recaptchaValue = recaptchaRef.current?.getValue();
        if (!recaptchaValue) {
            alert("Please complete the captcha.");
            return;
        }

        setIsSubmitting(true);

        const form = formRef.current;

        // Remove any previous hidden fields
        form.querySelectorAll(".dynamic-hidden").forEach((el) => el.remove());

        // 1. Encrypt data
        const key = "3E78jVr66otncsR32zDSOubz";
        //  const key = VTIGER_ENCRYPTION_KEY;
        const iv = CryptoJS.enc.Hex.parse("00000000000000000000000000000000");

        const encryptedData = CryptoJS.TripleDES.encrypt(
            JSON.stringify(data),
            CryptoJS.enc.Utf8.parse(key),
            {
                iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7,
            }
        ).toString();

        // 2. Encrypt key with RSA
        const rsa = new JSEncrypt();
        // rsa.setPublicKey(VTIGER_RSA_PUBLIC_KEY);
        rsa.setPublicKey(`-----BEGIN PUBLIC KEY-----MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA2K2OXmCc9hP4kioRqKKoQ5m+OZm4MmCzR3+tOUeJ3WtsPYfNGSEulfnNtXbJVtqZP8idT1egxBmpr+BI/j9itcE7NZqKvHWUCcAXv/d/fwo2M4YXXYQlJmda5y3PC69EI+rNDcElh+Lktpquq5bP3DffYKW76kH+LDgYDwNEtFTPk3uXftiYmF4j3PEDwb6TkPIHXIRQ9hx7T0br49AEVzUNKGCDyqJWo1VGvxbd5F7MH+3Gq+7vW+TaiCPiLhAjjS7GxTItmKXShHCtH8c55R34MPVQo69Ja+CVu1p/tyC/PRwRuC4CalyguUGsMbo53tpGyuHM9oqsW5edHVsbUwIDAQAB-----END PUBLIC KEY-----`);
        const encryptedKey = rsa.encrypt(key);

        // 3. Append encrypted fields + captcha + static fields
        const appendHidden = (name, value) => {
            const input = document.createElement("input");
            input.type = "hidden";
            input.name = name;
            input.value = value;
            input.classList.add("dynamic-hidden");
            form.appendChild(input);
        };

        appendHidden("data", encryptedData);
        appendHidden("encryptedKey", encryptedKey);
        appendHidden("g-recaptcha-response", recaptchaValue);

        // Static fields
        const staticFields = {
            publicid: "d30a5cbeb990e28450173ac773dd26f7",
            urlencodeenable: "1",
            name: "BOM GIFTSTACC WEBFORM",
            __vtCurrency: "1",
            title: "HDFC EMI WEBFORM Query",
            casechannel: "Webform",
            casestatus: "New",
            casepriority: "Low",
            group_id: "41",
            cf_cases_customer: "HDFC-EMI STORE",
            cf_cases_product: "Online Shopping",
            encryptionKey: key,
        };

        Object.entries(staticFields).forEach(([name, value]) =>
            appendHidden(name, value)
        );

        // 4. Submit
        form.submit();
    };
    const handleFileChange = (e) => {
        const selected = e.target.files[0];
        setFile(selected);
        //  setValue("file", selected, { shouldValidate: true });
    };
    return (
        <form
            ref={formRef}
            onSubmit={handleSubmit(onSubmit)}
            method="POST"
            action="https://customercapital.od2.vtiger.com/modules/Webforms/capture.php"
            encType="multipart/form-data"
            className="contact_modal"
            noValidate
            id="__vtigerWebForm_10"
        >
            <div className="">

                <div class="row align-items-center">
                    <div class="col-md-3 col-sm-12">
                        <label for="contact_id">Full Name <span class="req">*</span> </label>

                    </div>
                    <div class="col-md-9 col-sm-12">

                        <input type="text"
                            {...register("contact_id", { required: "Full name is required" })}

                        />
                        {errors.contact_id && <span class="req">{errors.contact_id.message}</span>}
                    </div>
                </div>
                <div class="row align-items-center">
                    <div class="col-md-3 col-sm-12">
                        <label htmlFor="email" >Email Address <span class="req">*</span> </label>

                    </div>
                    <div class="col-md-9 col-sm-12">

                        <input
                            type="email"
                            {...register("email", { required: "Email is required" })}

                        />
                        {errors.email && <span class="req">{errors.email.message}</span>}
                    </div>
                </div>

                <div class="row align-items-center">
                    <div class="col-md-3 col-sm-12">
                        <label class="" for="cf_cases_phonenumber">Contact No <span class="req">*</span> </label>

                    </div>
                    <div class="col-md-9 col-sm-12">
                        {/* <input name="cf_cases_phonenumber" type="tel" maxlength="10" data-label="" value="" required=""
                            oninput="this.value = this.value.replace(/[^0-9\-]/g, '')" /> */}


                        <input
                            type="tel"
                            maxLength={10}
                            onInput={(e) => (e.target.value = e.target.value.replace(/\D/g, ""))}
                            {...register("phone", {
                                required: "Phone number is required",
                                pattern: {
                                    value: /^\d{10}$/,
                                    message: "Enter a valid 10-digit number",
                                },
                            })}
                        />

                        {errors.phone && <span className="req">{errors.phone.message}</span>}




                    </div>
                </div>
                <div class="row align-items-center">
                    <div class="col-md-3 col-xs-3 ">
                        <label class="">Contact Me <span class="req">*</span> </label>

                    </div>
                    <div class="col-md-9 col-xs-9">
                        <input
                            type="checkbox"
                            {...register("contactMe", {
                                required: "You must agree to be contacted",
                            })}
                        />{" "}
                        {errors.contactMe && <span class="req">{errors.contactMe.message}</span>}

                    </div>
                </div>
                <div class="row align-items-center">
                    <div class="col-md-3 col-sm-12">
                        <label class="mb-2">Category <span class="req">*</span> </label>

                    </div>
                    <div class="col-md-9 col-sm-12">
                        <select {...register("cf_cases_chooseatopic", { required: true })}>
                            <option value="">Select Value</option>
                            <option value="Account or Login Issue">
                                Account or Login Issue
                            </option>
                            <option value="Point Earning Query">Point Earning Query</option>
                            <option value="Points Redemption Query">
                                Points Redemption Query
                            </option>
                            <option value="E-Gift Voucher - Specific Query">
                                E-Gift Voucher - Specific Query
                            </option>
                            <option value="E-Gift Voucher - Buying issue">
                                E-Gift Voucher - Buying issue
                            </option>
                            <option value="E-Gift Voucher - How to Redeem">
                                E-Gift Voucher - How to Redeem
                            </option>
                            <option value="E-Gift Voucher - Redemption Error">
                                E-Gift Voucher - Redemption Error
                            </option>
                            <option value="E-Gift Voucher - Other Issues">
                                E-Gift Voucher - Other Issues
                            </option>
                        </select>
                    </div>
                </div>


                <div className="row">
                    <div class="col-md-3 col-sm-12">
                        <label htmlFor="description" class="mt-2">Description <span class="req">*</span> </label>

                    </div>
                    <div class="col-md-9 col-sm-12">
                        <textarea
                            {...register("description", {
                                required: "Description is required",
                                maxLength: {
                                    value: 255,
                                    message: "Maximum 255 characters",
                                },
                            })}
                        />
                        {errors.description && <span class="req">{errors.description.message}</span>}
                    </div>

                </div>
                <div class="row">
                    <div class="col-md-3 col-sm-12">
                        <label htmlFor="cf_cases_fyndorderid" class="mt-2">Order ID (if applicable)</label>

                    </div>
                    <div class="col-md-9 col-sm-12">
                        <input type="text" {...register("orderId")} />
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-3 col-sm-12"> </div>
                    <div class="col-md-9 col-sm-12">
                        <div className="">
                            <input
                                type="file"
                                accept=".pdf,.jpg,.jpeg"
                                onChange={handleFileChange}
                            />
                            {errors.file && <p>{errors.file.message}</p>}
                            {file && <span class="req">Selected File: {file.name}</span>}

                            {/* <span className="text-sm font-medium text-doveGrey">Upload a file</span> */}
                        </div>

                    </div>
                </div>



                <div class="row">
                    <div class="col-md-3 col-sm-12">

                    </div>
                    <div class="col-md-9 col-sm-12">
                        {/* Register recaptcha field manually */}
                        <input
                            type="hidden"
                            {...register("recaptcha", {
                                required: "Please complete the CAPTCHA",
                            })}
                        />

                        <ReCAPTCHA
                            ref={recaptchaRef}
                            sitekey="6LcmdSATAAAAAGWw734vGo0AXQwuxJS7RmDZA_Fe"
                            onChange={(token) => {
                                setValue("recaptcha", token, { shouldValidate: true });
                                trigger("recaptcha"); // trigger validation
                            }}
                            onExpired={() => {
                                setValue("recaptcha", "", { shouldValidate: true });
                                trigger("recaptcha");
                            }}
                        />
                        {errors.recaptcha && (
                            <span className="text-red-500 req">{errors.recaptcha.message}</span>
                        )}

                    </div>
                </div>

                <div class="row mt-2">
                    <div class="col-md-3 col-sm-12"> </div>
                    <div class="col-md-9 col-sm-12">
                        <button
                            type="submit"
                            disabled={!isValid || isSubmitting}
                            className="submit btn-primary"
                        >
                            Submit
                        </button>
                    </div>
                </div>

            </div>
        </form>
    );
};

export default VtigerContactForm;
